export default __webpack_public_path__ + "static/media/illust_out.4bcbdab9.png";